import Error from '../common/errorData'
import CON from '../constant'
import {
  http
} from './index'
const pasurl = CON.URL_DOWN
const getReq = (url, data) => { // 封装get参数
  const urls = http.adornUrl(url, pasurl)
  return http.get(urls, {
    params: data
  })
}

const postReq = (url, data) => { // 封装post参数
  const urls = http.adornUrl(url, pasurl)
  return http.post(urls, data)
}
export default {
  login: (data) => postReq('/app-api/member/auth/login', data).then(Error),
  loginSms: (data) => postReq('/app-api/member/auth/sms-login', data).then(Error),
  sendSmsCode: (data) => postReq('/app-api/member/auth/send-sms-code', data).then(Error),
  loginByMobile: (data) => getReq('/app-api/member/auth/loginByMobile', data).then(Error)

}



// WEBPACK FOOTER //
// ./src/apis/leader.js